import { Card, Select, Avatar, Tag } from "antd";
import { useState } from "react";
import { EyeOutlined, UserOutlined } from '@ant-design/icons'
import TaskDetail from "./taskDetail";

export default function ProfileTaskCard({ id, details, profileSrc, name, department, tasks = [] }) {
  const [filterStatus, setFilterStatus] = useState("All");
  const [modalOpen, setModalOpen] = useState(false)
  const [taskDetailData, setTaskDetailData] = useState(null)
  const validTasks = tasks.filter(t =>
    t && t.taskID !== null && t.lastTaskName !== "No Task"
  );
  const taskCounts = {
    total: validTasks.length,
    inProcess: validTasks.filter(t => t.status === "In Process").length,
    assigned: validTasks.filter(t => t.status === "Assigned").length,
    pending: validTasks.filter(t => t.status === "Pending").length,
    completed: validTasks.filter(t => t.status === "Completed").length,
    onHold: validTasks.filter(t => t.status === "On Hold" || t.status === "OnHold").length,
    rejected: validTasks.filter(t => t.status === "Rejected").length,
    canceled: validTasks.filter(t => t.status === "Canceled").length,
  };


  const order = {
    "In Process": 1,
    "Assigned": 2,
    "Pending": 3,
    "On Hold": 4,
    "OnHold": 5,
    "Completed": 6,
    "Rejected": 7,
    "Canceled": 8,
    "Ended": 9
  };

  // const filteredTasks = (filterStatus === "All" ? tasks : tasks.filter(t => t.status === filterStatus))
  //   .filter(t => !(t.taskID === null && t.lastTaskName === "No Task"))
  //   .sort((a, b) => order[a.status] - order[b.status]);
  const filteredTasks = (filterStatus === "All"
    ? tasks
    : tasks.filter(t => t.status === filterStatus)
  )
    .filter(t => !(t.taskID === null && t.lastTaskName === "No Task"))
    .sort((a, b) => {
      // 1️⃣ Status-wise order
      const statusDiff = order[a.status] - order[b.status];
      if (statusDiff !== 0) return statusDiff;

      // 2️⃣ Same status → assign date DESC
      const dateA = new Date(a.assignDate); // 👈 yahan apni date field
      const dateB = new Date(b.assignDate);

      return dateB - dateA; // DESC (latest first)
    });

  const hasTasks = filteredTasks.length > 0;
  const formatDate = (d) => {
    if (!d) return '-'
    try {
      const dt = new Date(d);
      const day = String(dt.getDate()).padStart(2, '0');
      const month = String(dt.getMonth() + 1).padStart(2, '0'); // Month 0-based
      const year = String(dt.getFullYear()).slice(-2)

      return `${day}-${month}-${year}`;  // DD-MM-YYYY
    } catch (e) {
      return d
    }
  }
  const handleDetailTask = (id, name) => {
    // console.log(id)
    const findTask = details.find((item, i) => item.ID === id && item?.EMPLOYEE_NAME == name)
    // console.log("findTask",findTask)
    if (findTask) {
      setModalOpen(true)
      setTaskDetailData(findTask)
    }
  }

  return (
    <Card className="bg-gradient-to-br from-blue-50 to-blue-200 shadow-lg hover:shadow-xl w-full rounded-2xl font-sans mx-auto transition-all duration-300">
      {/* Top Section */}
      <div className="flex flex-col md:flex-row w-full items-start md:items-center gap-4 mb-3">
        {/* Avatar */}
        <div className="flex items-center gap-4">
          <Avatar
            size={64}
            src={profileSrc}
            icon={!profileSrc && <UserOutlined />}
            className="ring-4 shadow-md"
          />

          <div className="flex flex-col">
            <h3 className="text-lg font-bold text-gray-800">{name}</h3>
            <p className="text-sm text-gray-500">{department}</p>
            <Select
              size="small"
              value={filterStatus}
              onChange={setFilterStatus}
              style={{ width: 140 }}
              options={[
                { value: "All", label: "All" },
                { value: "Assigned", label: "Assigned" },
                { value: "In Process", label: "In Process" },
                { value: "Completed", label: "Completed" },
                { value: "Pending", label: "Pending" },
                { value: "On Hold", label: "On Hold" },
                { value: "Rejected", label: "Rejected" },
                { value: "Canceled", label: "Canceled" },
              ]}
            />
            {hasTasks ? (
              <Tag color="blue" className="font-medium text-xs mt-1 w-fit">
                Task Assigned {taskCounts.total}
              </Tag>
            ) : (
              <Tag color="red" className="font-medium text-xs mt-1 w-fit">
                No Task Yet
              </Tag>
            )}
          </div>
        </div>

        {/* Filter Select */}
        <div className="w-full md:w-auto flex justify-start md:justify-end">

        </div>
      </div>


      {/* Status Tags */}
      <div className="flex flex-wrap gap-2 mb-2">
        {/* <Tag color="purple" className="font-light text-xs">Total {taskCounts.total}</Tag> */}
        <Tag color="blue" className="font-light text-xs">Assigned {taskCounts.assigned}</Tag>
        <Tag color="yellow" className="font-light text-xs">Pending {taskCounts.pending}</Tag>
        <Tag color="orange" className="font-light text-xs">InProcess {taskCounts.inProcess}</Tag>
        <Tag color="green" className="font-light text-xs">Completed {taskCounts.completed}</Tag>
      </div>


      {/* Table */}
      <div className="w-full bg-white rounded-xl shadow-inner p-2 h-[230px] overflow-y-auto">

        {/* Header */}
        <div className="grid grid-cols-3 sm:grid-cols-5 pl-2 font-semibold text-xs text-gray-700 border-b pb-1 mb-2">
          <span>Project</span>
          <span className="hidden sm:block">Assigned</span>
          <span className="hidden sm:block">Due Date</span>
          <span>Status</span>
          <span className="text-center">View</span>
        </div>

        {/* Rows */}
        {hasTasks ? (
          filteredTasks.map((t, idx) => (
            <div
              key={idx}
              className="grid grid-cols-3 sm:grid-cols-5 items-center text-xs bg-blue-50 p-2 mb-1 rounded-lg border border-blue-100 hover:bg-blue-100 transition"
            >
              <span className="font-semibold break-words whitespace-normal">{t.projectName}</span>

              <span className="hidden sm:block">{formatDate(t.assignDate)}</span>
              <span className="hidden sm:block">{formatDate(t.dueDate)}</span>

              <span
                className={`font-medium ${t.status === "In Process"
                    ? "text-blue-600"
                    : t.status === "Completed"
                      ? "text-green-600"
                      : "text-gray-400"
                  }`}
              >
                {t.status}
              </span>

              <span
                className="text-center cursor-pointer"
                onClick={() => handleDetailTask(t?.taskID, name)}
              >
                <EyeOutlined />
              </span>
            </div>
          ))
        ) : (
          <p className="text-gray-400 text-center text-sm italic">No tasks found</p>
        )}
      </div>

      <TaskDetail open={modalOpen} taskData={taskDetailData} onClosed={() => setModalOpen(false)} />
    </Card>

  );
}
